'use strict';

+function ($) {
  // if a tab is disabled, prevent any action (pointer-events: none; doesn't work in IE 10)
  $(document).on('show.bs.tab', '.disabled [data-toggle="tab"]', false)

  // scroll tabs into view on really small screens
  .on('show.bs.tab', '.nav-tabs-responsive a[data-toggle="tab"]', function () {
    $(this).closest('.nav-tabs-responsive').animate({
      scrollLeft: $(this).offset().left - $(this).closest('.nav-tabs').offset().left - ($(this).closest('.nav-tabs-responsive').width() - $(this).outerWidth()) / 2
    }, 500);
  });

}(jQuery);



//////////////////
// WEBPACK FOOTER
// ./src/core/js/components/tab.js
// module id = 19
// module chunks = 0